import useCanToggleAiIntegration from "shared/AiIntegration/access/useCanToggleAiIntegration";
import { AiIntegrationView } from "shared/AiIntegration/useSearchAiIntegrations/gql";
import { useBulkToggleAiIntegration } from "shared/AiIntegration/useToggleAiIntegration";

import { AiIntegrationsBulkActions, AiIntegrationsBulkActionItem } from "../types";

const useDisableAiIntegrationBulkAction = (): AiIntegrationsBulkActionItem => {
  const [toggleAiIntegration] = useBulkToggleAiIntegration();
  const canToggleAiIntegration = useCanToggleAiIntegration();

  return {
    key: AiIntegrationsBulkActions.Disable,
    title: "Disable",
    resultTitle: "Disable integrations results",
    condition: (integration: AiIntegrationView) => {
      if (!integration.enabled) {
        return { result: false };
      }

      return canToggleAiIntegration(integration);
    },
    mutation: (integration: AiIntegrationView) =>
      toggleAiIntegration({
        id: integration.id,
        enabled: false,
      }),
  };
};

export default useDisableAiIntegrationBulkAction;
